module.exports = __webpack_public_path__ + "static/img/art-banner.7a6bc41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/art-banner.png
// module id = 1B0l
// module chunks = 1